export default __webpack_public_path__ + "static/media/sort.80b475b6.png";